import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { GETObservationListVM, GETObservationsCusVM } from '../entities/global/model';
import { ProgramImprovementService } from '../services/program-improvement.service';
import { CustomerSelectItem } from '../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { JobsiteSelectionFilter } from '../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { GenericIdName } from '../setup-implement/setup-implement.model';

@Component({
  selector: 'app-observation-list-customer',
  templateUrl: './observation-list-customer.component.html',
  styleUrls: ['./observation-list-customer.component.scss']
})
export class ObservationListCustomerComponent implements OnInit {

  constructor(private _equipmentService: GETSetupEquipmentService,
    private _appService: AppService,
    private _route: ActivatedRoute,
    private router:Router,
    private _programImprovementService :ProgramImprovementService,
    private _notify: NotificationsService,  
    private _favouriteDialogService:FavouriteDialogService) { }

  selectedCustomer:any;
  customerList: CustomerSelectItem[] = [];
  customerList_: CustomerSelectItem[] = [];
  isShowCustomer:boolean=false;
  CustomerId:number=0
  ObservationList:GETObservationListVM[]
  showObservationListTable:boolean
  observation:GETObservationsCusVM[]
  selectedObservationNameforList=""
  selectedListName
  selectedObservationName
  filteredCustomers: CustomerSelectItem[] = [];
  selectedFamily:any;
  familyList: any = [];
  selectedFamilies: any[] = [];
  filteredFamilies:GenericIdName[]=[];
  selectedFamilyName: string = "";
  selectedCustomerName: string = "";
  displayCustomerName:string="";
  selectedFamilyId:number;
  FamilyId:number;
  showAddnewPanelForObservation:boolean=false;
  showbutton:boolean=false;
  arr=[]
  showEditObservationTable:boolean=false
  hideObservationListTable:boolean=false
  observationListID:number
  deletearr:GETObservationsCusVM[]
  selectedObservationNameforListarr:GETObservationsCusVM[]=[]
  showEditBar:boolean=false
  showAddnewPanel:boolean=false;
  isChange: boolean = false;
  isFamily: boolean = false;
  colorHex?: string;
  colorIncludeInReport?: boolean = false;
  tempColor: string = '';
  showColorPicker: boolean = false;
  ngOnInit() {
    this._appService.setPageTitle('Observation List Customer');
    this.CustomerId = +this._route.snapshot.paramMap.get('Id');
    this.FamilyId = +this._route.snapshot.paramMap.get('FamId');
	  this.loadCustomers();
    this.loadAllFamilyList();
    if(this.CustomerId > 0){
     this.getObservationListforCus();
    }
  }

  getObservationListforCus(){
    this._programImprovementService.getObservationListforCustomer(this.selectedCustomer.Id, this.selectedFamily?.Id ?? 0).subscribe(res=>{
      this.ObservationList=res
      console.log("ObservationList",this.ObservationList)
      if(this.ObservationList.length>0){
         this.showObservationListTable=true
          // this.loadFamiliesForCustomer();
         console.log(this.ObservationList)
         console.log(this.showObservationListTable)
      } else {           
        this.showObservationListTable=false
      }
    })
  }

  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      this.customerList_ = r;
      this.filteredCustomers = this.customerList; 
    });
  }
 
  filterUsers(event){
    const filterValue = event.target.value.toLowerCase();
    this.customerList = this.customerList_.filter(option => option.Name.toLowerCase().includes(filterValue));
  }
  
  IsShowCustomer(){
    this.isShowCustomer=!this.isShowCustomer;
  }

  AddnewObservationtoSelectedCus(custId: number, familyId: number | null | undefined){
    console.log("Id",custId);
    console.log("familyId",familyId);
    this.selectedFamilyId =familyId;
    console.log("this.selectedFamilyId",this.selectedFamilyId);
    if (custId) {
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
      // this.router.navigate(['/observation-list-customer/' + custId + '/' + (familyId != null ? familyId : 0)]);  
      this._programImprovementService.getObservationListforCustomer(custId, (familyId != null ? familyId : 0)).subscribe(res=>{
         this.ObservationList=res
      if(this.ObservationList.length>0){
        this.showObservationListTable=true 

        console.log(this.ObservationList)
        console.log(this.showObservationListTable)
      }else {      
        this.showObservationListTable=false
      }
      })
    } 
  }
  NavigateSelectCustomerPage(){
    this.router.navigate(['/observation-list-customer/']);
  }

  ShowAddNewObservation(){
    this.showAddnewPanel=true
    this.arr=[]
    this.selectedListName=""
    this.showAddnewPanelForObservation=true
    // const familyId   = this.selectedFamily?.Id ?? 0;
    // this.router.navigate(['/observation-list-customer/' + this.selectedCustomer.Id + '/' + familyId]);
  }

  AddObservationtoArray() {
    const value = (this.selectedObservationName || '').trim();
    if (!value) {
      return;
    }
    const exists = this.arr.some(
      x => x.toLowerCase() === value.toLowerCase()
    );
    if (exists) {
      return;
    }
    this.arr.push(value);
    this.selectedObservationName = '';
    this.showbutton = true;
  }


  AddNewObservation(){
    if (!this.selectedListName || !this.selectedListName.trim()) {
    this._notify.alert('List Name is required');
    return;
  }
   console.log("this.selectedFamilyId",this.selectedFamilyId);
    let model=new GETObservationListVM()
    model.name=this.selectedListName
    model.customerID=this.selectedCustomer.Id 
    model.ObservatoinName=this.arr
    model.FamId = this.selectedFamily?.Id ?? 0;
    console.log(this.arr)
    this.CustomerId = this.selectedCustomer.Id;
    this.FamilyId = this.selectedFamily?.Id ?? 0;
   //model.ObservatoinName=this.selectedObservationName 
    this._programImprovementService.AddNewObservationPoint(model).subscribe(res=>{
      this.getObservationListforCus();
      this.showObservationListTable=true
      this.showAddnewPanel=false
      this.hideObservationListTable=false
      //this.selectedObservationNameforListarr=[]
      this._notify.success('Successfully Saved')
      this.goBack();
    })
    //this.selectedObservationNameforListarr=[]
  }

  getObservationforCustomer(observationList_auto, name, severityListFlag? : boolean){
    this.isFamily = this.selectedFamilyName != "" ? true : false; 
    console.log("this.", this.selectedFamilyName);
    this._programImprovementService.getObservationforCustomer(observationList_auto).subscribe(res=>{
      this.observation=res || [];
      console.log("this.observation for edit",res)
      console.log("this.observation for edit",this.observation)
      this.deletearr=this.observation
      //this.selectedListName=res[0].observationListname
      this.selectedListName = res[0]?.observationListname || "";
      this.observationListID=observationList_auto
      this.showEditObservationTable=true
      this.hideObservationListTable=true
      this.getObservationListforCus();
      this.selectedFamilyName = this.familyList.find(fam => fam.Id === this.observation[0].FamId)?.Name || "";
      this.showAddnewPanelForObservation = true;
      this.showColorPicker = severityListFlag;
    })
  }

  goBack(){
    this.showObservationListTable=true
    this.showAddnewPanel=false
    this.hideObservationListTable=false
    this.showEditObservationTable=false
    this.getObservationListforCus()
    this.showEditBar=false
    this.showAddnewPanelForObservation = false;
    this.showbutton=true;
    this.AddnewObservationtoSelectedCus(this.selectedCustomer?.Id, this.selectedFamily?.Id); 
    if(!this.isFamily)
      this.selectedFamilyName = "";
  }

AddObservationListtoArray() {
  console.log("this.selectedObservationNameforList", this.selectedObservationNameforList);
  const obs = (this.selectedObservationNameforList || '').trim();
  if (!obs) {
    console.warn("Empty observation blocked");
    return;
  }
  const alreadyExists = this.observation.some(
    x => x.observation?.toLowerCase() === obs.toLowerCase()
  );
  if (alreadyExists) {
    console.warn("Duplicate observation blocked");
    return;
  }
  const obj = {
    active: true,
    observation: obs,
    observationListname: this.selectedListName,
    observation_auto: 0,                
    observation_list_auto: this.observationListID,
    FamId: this.selectedFamilyId ?? 0,
    ColorCode: this.colorHex || null,
    ColorIncludeInReport: false,  
    isNew: true             
  };
  this.selectedObservationNameforListarr.push(obj);
  this.observation.push(obj);
  this.deletearr = this.observation;
  console.log("selectedObservationNameforListarr", this.selectedObservationNameforListarr);
  console.log("observation", this.observation);
  this.selectedObservationNameforList = '';
  this.isChange = true;
}
  detectChange(): void {
    this.isChange = true;
  }

  AddNewObservationToList(){
    console.log("delete arr", this.deletearr)
    console.log("selectedcustomer",this.selectedObservationNameforListarr)
    if(!this.isFamily)
      this.selectedFamilyName = "";
    if (!this.selectedListName || !this.selectedListName.trim()) {
      this._notify.alert('List Name is required');
      return;
    }
    if (!this.isChange) {
      this.goBack();
      return;
    }
    this.selectedObservationNameforListarr=this.deletearr
    this._programImprovementService.AddNewObservationPointforList(this.observationListID,this.selectedListName,this.selectedObservationNameforListarr, this.selectedFamilyId)
    .subscribe(res=>{
       // this.getObservationforCustomer(this.observationListID, "")
      this.getObservationListforCus();
      this.showObservationListTable=true
      this.showAddnewPanel=false
      this.hideObservationListTable=false
      this.showEditObservationTable=false
      this._notify.success('Successfully Saved')
      this.selectedObservationNameforListarr=[]
      this.goBack();
      this.isChange = false;
    })
    this.selectedObservationNameforListarr=[]
  }

  deletefromArray(i){
    this.deletearr=this.observation
    let array =[];
    array=this.deletearr;  
    array.splice(i,1)  
    this.deletearr=array 
   // this.selectedObservationNameforListarr=this.deletearr
  }

  onObservationActiveChange(ob: any, isChecked: boolean) {
    ob.active = isChecked;
    this.isChange = true;
  }

  deleteObservation(observationId, observatinListID, isActive?: boolean) {
    console.log("this.observation:", this.observation);
    var flag = this.observation.filter(f => f.observation_auto == observationId)[0].active;
    console.log("this.observation flag:", flag);
    this._programImprovementService.deleteObservation(observationId, flag).subscribe(res=>{
      if(res==true){
        this.getObservationforCustomer(observatinListID, "")
        this._notify.success('Successfully Updated')
      }
    })   
  }

  deleteObservationList(observationList_auto: number, e: any) {
    //console.log("flag:", e.checked);
    var flag = this.ObservationList.filter(f => f.observationList_auto == observationList_auto)[0].active;
    this._programImprovementService.deleteObservationList(observationList_auto, flag).subscribe(res=>{
      if (res == true) {
          //console.log("flag:", flag);
        this.getObservationListforCus()
        this.showEditObservationTable=false
        this.AddnewObservationtoSelectedCus(this.selectedCustomer?.Id, this.selectedFamily?.Id);  
        this._notify.success('Successfully Updated')
      } 
    })  
  }

  setCrackSeverityListFlag(observationList_auto, e: any) {
    //console.log("this.ObservationList:", this.ObservationList, e);
   // console.log("this.ObservationList sel:", this.ObservationList.filter(f => f.observationList_auto == observationList_auto)[0]);
   let obs = this.ObservationList.find(f => f.observationList_auto === observationList_auto);
    if (!obs) return;
    if (obs.CrackSeverityList) {
      obs.CrackObsList = false;  // uncheck opposite
    }
    var flag = this.ObservationList.filter(f => f.observationList_auto == observationList_auto)[0].CrackSeverityList;
    this._programImprovementService.setCrackSeverityListFlag(observationList_auto, flag, 1).subscribe(res => {
      if (res == true) {
        console.log("flag:", flag);
        this.getObservationListforCus()
        this.showEditObservationTable = false
        this.AddnewObservationtoSelectedCus(this.selectedCustomer?.Id, this.selectedFamily?.Id);  
        this._notify.success('Successfully Updated.')
      }
    })
  }

  setObsListFlag(observationList_auto, e: any) {
    //console.log("this.ObservationList:", this.ObservationList, e);
   // console.log("this.ObservationList sel:", this.ObservationList.filter(f => f.observationList_auto == observationList_auto)[0]);
    let obs = this.ObservationList.find(f => f.observationList_auto === observationList_auto);
    if (!obs) return;
    if (obs.CrackObsList) {
      obs.CrackSeverityList = false;  // uncheck opposite
    }
    var flag = this.ObservationList.filter(f => f.observationList_auto == observationList_auto)[0].CrackObsList;
    this._programImprovementService.setCrackSeverityListFlag(observationList_auto, flag, 2).subscribe(res => {
      if (res == true) {
        console.log("flag:", flag);
        this.getObservationListforCus()
        this.showEditObservationTable = false
        this.AddnewObservationtoSelectedCus(this.selectedCustomer?.Id, this.selectedFamily?.Id);  
        this._notify.success('Successfully Updated.')
      }
    })
  }


  deletefromArrayNewList(ob,i){
    let array =[];
    array=this.arr;  
    array.splice(i,1)  
    this.arr=array  
    console.log( this.arr)
  }

editingIndex: number | null = null;

ShoweditObservation(ob: GETObservationsCusVM, i: number) {
  if (this.editingIndex === i) {
    this.editingIndex = null; // toggle off
  } else {
    this.editingIndex = i;    // edit only this row
  }
  this.isChange = true;
}

  EditObservation(ob:GETObservationsCusVM){
      this.editingIndex = null;
    this._programImprovementService.updateObservation(ob.observation_auto, ob.observation).subscribe(res=>{
      if (res == true) {
        this.getObservationListforCus();
        this._notify.success('Successfully Updates')
        this.showEditBar=false;
        this.isChange = true;
      }
    })
  }

  onClick(){
    this.displayCustomerName = this.selectedCustomerName;
    this.AddnewObservationtoSelectedCus(this.selectedCustomer?.Id, this.selectedFamily?.Id);  
    this.showbutton = true;
    //this.selectedFamilyName = this.selectedFamily ? this.selectedFamily[0].Name : '';
  }

  showAllCustomers() {
    this.filteredCustomers = this.customerList.slice();
  }
  showAllFamilies() {
    this.filteredFamilies = this.familyList.slice();
  }

  filterCustomers() {
    const value = this.selectedCustomerName.toLowerCase();
    this.filteredCustomers = this.customerList.filter(c =>
      c.Name.toLowerCase().includes(value)
    );
  }

  selectCustomer(event: any) {
    const name = event.option.value;
    this.selectedCustomer = this.customerList.find(c => c.Name === name);
    console.log("selectedCustomer",this.selectedCustomer);
    this.loadFamiliesForCustomer();
  }

  loadFamiliesForCustomer() {

    if (!this.selectedCustomer && this.CustomerId <= 0) {
      this.loadAllFamilyList();
      return;
    }
    let customerIdToUse = this.selectedCustomer?.Id ? this.selectedCustomer.Id : this.CustomerId;
    let params: JobsiteSelectionFilter = {
      Customers: [customerIdToUse]
    };
    this._favouriteDialogService.GetFamiliesForSelectedCustomers(params)
      .subscribe(r => {
        if (r && r.length > 0) {
          this.familyList = r;     
          this.filteredFamilies = r;     
        } else {
          this.familyList = this._favouriteDialogService.availableFamilyList;
          this.filteredFamilies = this.familyList;
        }
        console.log("familyList",this.familyList);
        console.log("filteredFamilies",this.filteredFamilies);
      });
  }


  loadAllFamilyList() {
    this._favouriteDialogService.getllFamilyList().subscribe(res => {
      this.familyList = res;
      this.filteredFamilies = this.familyList.slice(); // initialize!
      console.log("familyList res", this.familyList);

      if (this.FamilyId > 0) {
        this.selectedFamily = this.familyList.find(f => f.Id === this.FamilyId) ?? null;
        this.selectedFamilyName = this.selectedFamily ? this.selectedFamily.Name : this.selectedFamilyName;
      }
    });
  }

  selectFamily(event: any): void {
    const familyName = event.option.value as string; // because [value]="fam.Name"
    this.selectedFamily = this.familyList.find(f => f.Name === familyName) ?? null;
    this.selectedCustomerName = this.selectedCustomer ? this.selectedCustomer.Name : this.selectedCustomerName;
    this.selectedFamilyId = this.selectedFamily ? this.selectedFamily.Id : null;
    this.selectedFamilyName = familyName; // keep input synced with selection
    this.isChange = true;
    console.log("selectedFamily", this.selectedFamily);
  }

  filterFamilies(): void {
    const value = (this.selectedFamilyName || '').toLowerCase().trim();
    this.filteredFamilies = value
      ? this.familyList.filter(fam => (fam.Name || '').toLowerCase().includes(value))
      : this.familyList.slice(); // show all on blank
  }

  onFamilyInputChange(value: string) {
    const term = (value || '').trim();
    this.selectedFamilyName = value; // keep model in sync

    if (!term) {
      // clear selection but keep the dropdown populated
      this.selectedFamily = null;
      this.selectedFamilyId = null;
      this.filteredFamilies = this.familyList.slice();
    } else {
      this.filterFamilies();
    }
  }


  //loadAllFamilyList(){
  //  this._favouriteDialogService.getllFamilyList().subscribe(res=>{
  //    this.familyList =res;
  //    this.filteredFamilies = res;
  //    console.log("familyList res",this.familyList);
  //    if(this.FamilyId>0){
  //      this.selectedFamily = this.familyList.find(f => f.Id === this.FamilyId);
  //      this.selectedFamilyName = this.selectedFamily ? this.selectedFamily.Name : this.selectedFamilyName;
  //    }
  //  });
  //}

  //selectFamily(event: any): void {
  //  const familyName = event.option.value;
  //  this.selectedFamily = this.familyList.find(f => f.Name === familyName);
  //  this.selectedCustomerName = this.selectedCustomer ? this.selectedCustomer.Name : this.selectedCustomerName;
  //  console.log("selectedFamily",this.selectedFamily);
  //  this.selectedFamilyId = this.selectedFamily ? this.selectedFamily.Id : null;
  //  this.isChange = true;
  //}

  //filterFamilies(): void {
  //  const value = this.selectedFamilyName?.toLowerCase() || '';
  //  this.filteredFamilies = this.familyList.filter(fam =>
  //    fam.Name.toLowerCase().includes(value)
  //  );
  //}

  //onFamilyInputChange(value: string) {
  //  if (!value || value.trim() === '') {
  //    this.selectedFamilyName = '';
  //    this.selectedFamily = null;
  //    this.selectedFamilyId = null;   
  //    this.filteredFamilies = [];
  //  } else {
  //    this.filterFamilies();
  //  }
  //}


  resetFilters(): void {
    // Reset Customer
    this.selectedCustomer = null;
    this.selectedCustomerName = '';
    this.filteredCustomers = this.customerList.slice();
    // Reset Family
    this.selectedFamily = null;
    this.selectedFamilyName = '';
    this.filteredFamilies = this.familyList.slice();
    this.ObservationList = [];
    this.showbutton = false;
  }

  openColorPicker(ob: any) {
    this.tempColor = ob.ColorCode || '#FFFFFF';
  }

  applyColor(color: string, ob: any) {
    ob.ColorCode = color;
    this.isChange = true;
  }
  onColorIncludeChange(ob: any, checked: boolean) {
    ob.ColorIncludeInReport = checked;
    this.isChange = true;
  }
}

